import React, { useState, useEffect } from 'react';

import { useSelector } from 'react-redux';

import { getInitials } from '../../../common/utility/getInitials';

import { RootState } from '../../../redux/store';

import { IUserIcon } from '../types/IUserIcon';

import UserNavigation from '../navigation/userNavigation/userNavigation';

import './userIcon.scss';

const UserIcon: React.FC<IUserIcon> = ({ id }) => {
  const [userName, setUserName] = useState<string>('');
  const [nav, setNav] = useState<boolean>(false);

  const user: string | null | undefined = useSelector((state: RootState) => state.user.name);

  const clickHandler = (e: any) => {
    e.stopPropagation();
    setNav(!nav);
  };

  useEffect(() => {
    user && setUserName(getInitials(user.trim()));
  }, [user]);

  return (
    <div id={id} className='user-icon-wrapper'>
      <div id={id} className='user-btn pointer' onClick={clickHandler}>
        <span id={id} className='user-icon initials pointer'>
          {userName && userName.toUpperCase()}
        </span>
      </div>
      {nav && <UserNavigation setNav={setNav} id={id} />}
    </div>
  );
};

export default UserIcon;
